<template>
    <div :class="['tab', { 'tab-active' : isActive }]" @click="onClick">
        <slot></slot>
    </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
    name: "VTab",
    props: {
        label: { type: String },
        isActive: {
            type: Boolean,
            default: false
        },
        form: { type: String}
    },
    methods: {
        ...mapMutations('forms', {
            setActiveFrom : 'SET_ACTIVE_FORM'
        }),

        onClick: function() {
            if(!this.form) return;
            this.setActiveFrom({ form: this.form })
        }
    }

};
</script>

<style scoped lang="scss">
.tab{
    cursor: pointer;
    margin: 0 30px;
    color: #e4e8ec;
    
    &-active{ color: #000000; }
}
</style>